import React from 'react';
import { Grid, Header, Icon, List, Menu, Segment, Label, Button, Message, Popup } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import 'moment/min/locales';
import { FormattedMessage } from 'react-intl';
import { IconHeader } from '../Assets/util/css';


export default class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // newNotifications: JSON.parse(localStorage.getItem('newNotifications')) ? JSON.parse(localStorage.getItem('newNotifications')) :
            //     this.props.newNotifications ? this.props.newNotifications : [],
            newNotifications: [],
            answerIndex: parseInt(localStorage.getItem('answerIndex'), 10)
        };
        this.putNotification = this.putNotification.bind(this);
        this.markAllAsRead = this.markAllAsRead.bind(this);
        this.fetchNewNotification = this.fetchNewNotification.bind(this);
    }

    componentDidMount() {
        this.fetchNewNotification();
    }

    fetchNewNotification() {
        this.setState({ loading: true });
        axios.get('/notifications/user/')
            .then(res => {
                const newNotifications = res.data.reverse();

                this.setState({ newNotifications, loading: false });
                // localStorage.setItem('newNotifications', JSON.stringify(newNotifications));
            })
            .catch(err => {
                console.log('Failed to fetch new notifications.');
            });
    }

    putNotification(ids, index) {
        axios.put('notifications/change-seen-status/', ids)
            .then(res => {
                localStorage.setItem('answerIndex', index);
                this.fetchNewNotification();
            })
            .catch(err => {
                toast('Došlo je do greške!');
            });
    }

    markAllAsRead() {
        axios.put('notifications/mark-all-as-read/')
            .then(res => {
                this.fetchNewNotification();
            })
            .catch(err => {
                toast('Došlo je do greške!');
            });
    }

    render() {
        // eslint-disable-next-line no-unused-expressions
        window.$locale === 'en' ? moment.locale('en-gb') : moment.locale('bs');
        return (
            <div>
                <Header as="h1">  <FormattedMessage id="common.notifications" /></Header>
                <Grid columns={2} stackable centered >
                    <Grid.Row stretched>
                        <Grid.Column width={16} >

                            <Segment.Group raised clearing>
                                <Segment clearing>
                                    <Header as="h3" >
                                        {this.state.newNotifications.length === 0 || this.state.newNotifications.filter((e) => !e.seen).length === 0 ?
                                            <span>
                                                <Icon
                                                    link
                                                    circular
                                                    basic
                                                    style={{ fontSize: '15px', border: '1px solid #1a6aa5' }}
                                                    floated="right"
                                                    name="bell"
                                                    color="teal"

                                                />
                                            </span> :
                                            <span>

                                                <Icon
                                                    link
                                                    circular
                                                    basic
                                                    style={{ fontSize: '15px', border: '1px solid #1a6aa5' }}
                                                    floated="right"
                                                    name="bell"
                                                    color="teal"

                                                />
                                            </span>
                                        }
                                        <span>  <FormattedMessage id="common.newNotifications" /> </span>

                                        <Header as="h3" floated="right" >
                                            <span>
                                                <Popup
                                                    content={() => <FormattedMessage id="common.markAllAsRead" />}
                                                    position="left center"
                                                    trigger={
                                                        <Label basic as="a" onClick={this.markAllAsRead} disabled={!this.state.newNotifications.filter((e) => !e.seen).length}>
                                                            <Icon name={this.state.newNotifications.filter((e) => !e.seen).length ? 'mail' : 'mail'} />
                                                            {this.state.newNotifications.filter((e) => !e.seen).length > 99 ? '99+' : this.state.newNotifications.filter((e) => !e.seen).length }
                                                            <Label.Detail>Označi sve kao pročitano</Label.Detail>
                                                        </Label>

                                                    }
                                                />
                                                {/* <Button */}
                                                {/*    as={Icon} */}
                                                {/*    circular */}
                                                {/*    basic */}
                                                {/*    style={{ */}
                                                {/*        fontSize: '15px', border: '1px solid #1a6aa5', marginRight: '-8px' */}
                                                {/*    }} */}
                                                {/*    disabled={!this.props.newNotifications.filter((e) => !e.seen).length} */}
                                                {/*    floated="right" */}
                                                {/*    color="teal" */}
                                                {/*    onClick={this.markAllAsRead} */}
                                                {/*    name={this.props.newNotifications.filter((e) => !e.seen).length ? 'envelope outline' : 'envelope open outline'} */}
                                                {/* /> */}


                                            </span>
                                        </Header>
                                    </Header>
                                </Segment>

                                <Segment > {this.state.newNotifications.length === 0 ?
                                    <p><FormattedMessage id="common.noNewNotifications" /></p> :
                                    <Menu vertical fluid divided relaxed style={{ marginBottom: '12px' }}>
                                        {this.state.newNotifications.map((el, index) =>
                                            (<Menu.Item
                                                style={!el.seen ? { backgroundColor: '#dff0f7' } : {}}
                                                active={index === this.state.answerIndex}
                                                onClick={() => {
                                                    !el.seen && this.putNotification([el.id], index);
                                                    el.seen && this.setState({ answerIndex: index === this.state.answerIndex ? null : index });
                                                    el.seen && localStorage.removeItem('answerIndex');
                                                }}
                                            >
                                                {!el.seen && <Label color="teal"><FormattedMessage id="common.new" /></Label>}
                                                {/* <Icon name="chevron right" size="large" verticalAlign="middle" style={{ color: '#1a6aa5' }} /> */}
                                                <List.Content>
                                                    <List.Header as="h4" style={{ color: '#1a6aa5' }}>
                                                        {el.notification ? el.notification.subject : 'Nema teksat.'}
                                                    </List.Header>

                                                    { index === this.state.answerIndex && <List.Description style={{
                                                        textAlign: 'justify', textJustify: 'inter-word', color: '#000000', paddingRight: '15px'
                                                    }}
                                                    > {el.notification && <UnsafeComponent html={el.notification.text} />}
                                                        <br />
                                                    </List.Description>}

                                                    <List.Description as="h6" style={{ color: 'gray' }}>
                                                        <Icon color="teal" name="user" />
                                                        &nbsp;
                                                        {

                                                            el.notification && el.notification.sender ?
                                                                el.notification.sender.employee.person.lastName + ' ' + el.notification.sender.employee.person.firstName + '    '
                                                                : 'eUNSA '
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Icon color="teal" name="calendar alternate outline" />
                                                        &nbsp;
                                                        {

                                                            moment(el.notification && el.notification.timestamp).calendar(null, window.$locale === 'bs' ? {
                                                                sameDay: '[danas u] LT',
                                                                nextDay: '[sutra u] LT',
                                                                nextWeek: 'D. M. YYYY. [u] LT',
                                                                lastDay: '[jučer u] LT',
                                                                lastWeek: 'D. M. YYYY. [u] LT',
                                                                sameElse: 'D. M. YYYY. [u] LT'
                                                            } : {
                                                                lastDay: '[Yesterday at] LT',
                                                                sameDay: '[Today at] LT',
                                                                nextDay: '[Tomorrow at] LT',
                                                                lastWeek: 'D. M. YYYY. [at] LT',
                                                                nextWeek: 'D. M. YYYY. [at] LT',
                                                                sameElse: 'D. M. YYYY. [at] LT'
                                                            })
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Icon color="teal" name="mail" />
                                                        &nbsp;
                                                        {
                                                            el.notification && el.notification.notificationType &&
                                                                el.notification.notificationType.name
                                                        }
                                                    </List.Description>


                                                </List.Content>
                                            </Menu.Item>))}
                                    </Menu>

                                }
                                </Segment>

                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row >
                </Grid>

            </div>
        );
    }
}

function UnsafeComponent({ html }) {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}



// WEBPACK FOOTER //
// ./src/views/Notifications/Notifications.js